import { Component, EventEmitter, Input, Output } from "@angular/core";
import { transition, trigger, style, animate } from "@angular/animations";

@Component({
  selector: "app-mobile-introduction",
  templateUrl: "mobile-introduction.component.html",
  styleUrls: ["mobile-introduction.component.scss"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateX(-100%)" }),
        animate(
          "300ms ease",
          style({ opacity: 1, transform: "translateX(0)" }),
        ),
      ]),
      transition(":leave", [
        animate(
          "300ms ease",
          style({ opacity: 0, transform: "translateX(-100%)" }),
        ),
      ]),
    ]),
  ],
  standalone: false,
})
export class MobileIntroductionComponent {
  @Input() slides = [];
  @Input() currentSlide = 0;
  @Input() isFirstStep = true;
  @Input() isTwoButtons = true;
  @Input() isFinalStep = true;

  @Output() previous = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();

  onPrevious() {
    this.previous.emit();
  }

  onNext() {
    this.next.emit();
  }

  onSkip() {
    this.skip.emit();
  }
}
